import MasterButton from "./MasterButton";
import SmallButton from "./SmallButton";

export const Button = {
    Master: MasterButton,
    Small: SmallButton,
};
